import React from 'react';
import Grid from '@material-ui/core/Grid';
import MDXParser from '../mdxParser';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import DriversOfHungerSVG from '../driversOfHunger';
import FoodCrisesSVG from '../foodCrises';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';

import hunger1 from '../../images/hunger1.svg';
import hunger2 from '../../images/hunger2.svg';
import hunger3 from '../../images/hunger3.svg';

import globalmap from '../../images/worldmap.svg';

import GlobalReportContent from '../../sections/GlobalReport/GlobalReportFoodCrises';
import GlobalReportContentTwo from '../../sections/GlobalReport/GlobalReportFoodCrisesTwo';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '60px 0',
      background: `url(${globalmap}) no-repeat center center`,
      backgroundSize: 'cover',
      backgroundColor: '#94cfe5',
    },
    list: {
      padding: '20px 0',
    },
    title: {
      color: '#191a19',
      padding: '10px 0px 15px 5px',
    },
    subTitle: {
      fontStyle: 'italic',
      color: '#191a19',
      padding: '5px 5px',
    },
    primary: {
      color: '#191a19',
      fontWeight: 'bold',
    },
    secondary: {
      color: '#191a19',
    },
    mainTitle: {
      padding: '0px 0px 10px 0px',
      color: '#191a19',
      borderBottom: '2px solid #191a19'
    }
  }),
);

type Props = { children: React.ReactNode; image: string };

const GlobalReportSection = () => {
  const classes = useStyles();

  return (
    <Container maxWidth={false} disableGutters={true} className={classes.root}>
      <Container className={classes.container}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Typography variant="h1" className={classes.mainTitle}>GLOBAL REPORT ON FOOD CRISES</Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <MDXParser>
              <GlobalReportContent />
            </MDXParser>
          </Grid>

          <Grid item xs={12} md={6}>
            <MDXParser>
              <GlobalReportContentTwo />
            </MDXParser>
          </Grid>

          <Grid item xs={12} md={6} className={classes.hunger}>
            <Typography variant="h3" className={classes.title}>
              DRIVERS OF HUNGER (2019)
            </Typography>
            <Typography variant="h4" className={classes.subTitle}>
              Drivers of hunger before the COVID-19 pandemic
            </Typography>
            <Grid item xs={12}>
              <DriversOfHungerSVG />
            </Grid>
          
          </Grid>
          <Grid item xs={12} md={6} className={classes.hunger}>
            <Typography variant="h3" className={classes.title}>
              THE 10 WORST FOOD CRISES IN 2019
            </Typography>
            <Typography variant="h4" className={classes.subTitle}>
              By number of people in crisis or worse
            </Typography>
            <Grid item xs={12}>
              <FoodCrisesSVG />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Container>
  );
};

export default GlobalReportSection;
